/**
 * index.js — Application bootstrap
 *
 * Mounts the React app into the <div id="root"> element defined in
 * public/index.html. React.StrictMode is enabled in development to surface
 * deprecated API usage and unexpected side-effects during double-renders.
 * It has no effect in the production build.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Record when the PWA started loading so App.js can enforce a minimum splash
// display time of 1 second. The splash itself is dismissed by SplashController
// in App.js once the auth check has resolved AND the minimum time has elapsed.
window.__splashStart = Date.now();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Register the push-notification service worker (/public/sw.js).
// Runs after React mounts to avoid blocking the first paint.
// In dev, the SW still registers but push delivery requires a real VAPID key.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('[SW] Registration failed:', err);
    });
  });
}
